module.exports = __webpack_public_path__ + "static/media/health_care.37b34859.png";